"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnSharpLeftIcon = PrintableTurnSharpLeftIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnSharpLeftIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M0 12.002c0 6.616 5.383 11.998 12 11.998s12-5.382 12-11.998-5.384-12.002-12-12.002-12 5.385-12 12.002zM1.080 12.002c0-6.023 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 3.985-2.154 7.468-5.351 9.375v-12.338c0-0.954-0.57-2.755-2.727-2.755-1.371 0-2.769 1.474-2.923 1.644l-5.356 5.438v-6.022c0-0.311-0.252-0.563-0.563-0.563s-0.563 0.252-0.563 0.563v7.5c0 0.311 0.252 0.563 0.563 0.563h7.5c0.311 0 0.563-0.252 0.563-0.563s-0.252-0.563-0.563-0.563h-6.261l5.493-5.575c0.471-0.51 1.446-1.295 2.109-1.295 1.559 0 1.602 1.464 1.602 1.63v12.926c-1.357 0.609-2.859 0.954-4.443 0.954-6.023 0-10.92-4.898-10.92-10.918z",
    fill: color
  }));
}